module.exports = __webpack_public_path__ + "img/icon5.2a82341a.png";